<template>
  <DialogLayout
    title="新規追加"
    :visible.sync="dialogVisible"
    width="40em"
    @open="open"
  >
    <template #form>
      <LandingPassengersDataForm
        ref="landingPassengersDataForm"
        v-model="landingPassengersDataFormModel"
        label-width="10em"
        formMode="register"
        billingYmMode="input"
        :autocomplete-airport-code-set="autocompleteAirportCodeSet"
        :autocomplete-customer-code-set="autocompleteCustomerCodeSet"
      />
    </template>
    <template #footer>
      <RegisterDialogFooter
        @clear="clickClear"
        @register="clickRegister"
      />
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import LandingPassengersDataForm from '@/components/organisms/dialog/data/LandingPassengersDataForm.vue'
import RegisterDialogFooter from '@/components/organisms/dialog/RegisterDialogFooter.vue'
import AirportAutocompleteLoader from '@/mixins/AirportAutocompleteLoader.vue'
import CustomerAutocompleteLoader from '@/mixins/CustomerAutocompleteLoader.vue'

export default {
  components: {
    DialogLayout,
    LandingPassengersDataForm,
    RegisterDialogFooter
  },
  mixins: [
    AirportAutocompleteLoader,
    CustomerAutocompleteLoader
  ],
  props: {
    autocompleteCustomerCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteAirportCodeSet: {
      type: Array,
      default: () => ([])
    },
    currentRow: {
      type: Object,
      default: () => {
        return {}
      }
    },
    visible: Boolean
  },
  data () {
    return {
      landingPassengersDataFormModel: {
        billing_ym: undefined,
        bill_to_code: undefined,
        departure_airport_code: undefined,
        paid_flights: undefined,
        seats: undefined,
        paid_passengers: undefined,
        aircraft_weight_type: undefined
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (visible) {
        this.$emit('update:visible', visible)
      }
    }
  },
  mounted () {
  },
  methods: {
    clickClear () {
      this.$refs.landingPassengersDataForm.clearFields()
    },
    async clickRegister () {
      this.$loadingMask.on()
      this.$refs.landingPassengersDataForm.validate()
        .then((valid) => {
          return this.$axios.post('/landing-passengers-data', this.landingPassengersDataFormModel)
        })
        .then((res) => {
          this.$fcMessage.showMessage(res.data.message)
          this.dialogVisible = false
          this.$emit('refresh', this.landingPassengersDataFormModel.billing_ym)
        })
        .catch((e) => {
          if (e.response) {
            switch (e.response.status) {
              case 402:
                this.$fcMessage.showMessage(e.response.data.message)
                break
              default:
            }
          }
        })
        .finally(() => {
          this.$loadingMask.off()
        })
    },
    open () {
      const trimItem = ['bill_to_code', 'departure_airport_code']
      this.$nextTick(() => {
        this.$refs.landingPassengersDataForm.clearFields()
        Object.keys(this.landingPassengersDataFormModel)
          .forEach((x) => {
            if (trimItem.includes(x) && this.currentRow[x]) {
              this.currentRow[x] = this.currentRow[x].trimEnd()
            }
            this.$set(this.landingPassengersDataFormModel, x, this.currentRow[x])
          })
      })
    }
  }
}
</script>

<style lang="scss">
  // 実績年月の表示追加
  .el-form-item{
    white-space: nowrap;
  }
</style>
